import Image from 'next/image';
import './CoursesInsuranceBanner.scss';
import LinkWithTracking from '../../LinkWithTracking/LinkWithTracking';

export default function CoursesInsuranceBanner() {
  return (
    <section className="coursesInsuranceBanner">
      <Image
        alt=""
        src={require('@assets/images/courses/piggy-bank.webp')}
        className="coursesInsuranceBanner-image"
        sizes="(min-width: 768px) 327px, 125px"
      />
      <div className="coursesInsuranceBanner-container">
        <h2 className="coursesInsuranceBanner-title">
          Vergoed door jouw zorgverzekeraar
        </h2>

        <p className="coursesInsuranceBanner-text">
          Veel aanvullende verzekeringen vergoeden (een deel van) een
          zwangerschapscursus. Dit betekent dat jij onze cursussen (bijna)
          gratis kan volgen. Bekijk snel of jouw zorgverzekering de cursussen
          vergoed.
        </p>

        <LinkWithTracking
          href="/verzekering/cursus-vergoeding"
          className="coursesInsuranceBanner-button"
          target="_blank"
          category="welkom-lander"
          action="click-check-jouw-vergoeding"
        >
          Check jouw vergoeding
        </LinkWithTracking>
      </div>
    </section>
  );
}
